
import { Component, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { PageBase } from 't4core';
@Component({
    styleUrls: ['./DailySales.css'],
    selector: 'DailySales',
    templateUrl: './DailySales.component.html',
})
export class DailySalesComponent extends PageBase {
    private _from: moment.Moment = this.now.clone();
    private _to: moment.Moment = this.now.clone();
    public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };

    public get from(): moment.Moment { return this._from; }
    public set from(val: moment.Moment) {
        if (this._from != val) {
            this._from = val;
            this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
        }
    }

    public get to(): moment.Moment { return this._to; }
    public set to(val: moment.Moment) {
        if (this._to != val) {
            this._to = val;
            this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
        }
    }

    public updateParams() {
        this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    }

    constructor(el: ElementRef) {
        super(el, "DailySales");
    }

    public sumAmount(data: any[]): number { var x = 0; for (var i of data) x += i.Amount; return x; }
    public sumVAT(data: any[]): number { var x = 0; for (var i of data) x += i.VAT; return x; }
    public sumTotal(data: any[]): number { var x = 0; for (var i of data) x += i.Total; return x; }

}
